import React, {Component} from 'react';
import {connect} from 'react-redux';
import Settings from './components/settings';
import Stacks from './components/stacks';
import Action from 'components/organisms/player-name-stacking/actions';

class PlayerNameStacking extends Component {
    onClick(use) {
        this.props.dispatch(Action.do('usePlayerNameStacking', !use));
    }

    render() {
        const {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        return (
            <div className={`advanced-filter${stacking.isEnabled() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Disable Stacking Options
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isEnabled())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Legacy Stacking System
                    </button>
                </div>
                <Settings />
                {stacking.isEnabled() ? <Stacks /> : null}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerNameStacking, sportConfig} = state;

    return {
        sportConfig,
        stacking: playerNameStacking,
    };
}

export default connect(mapStatesToProps)(PlayerNameStacking);
